import React, { useState } from "react";

export default function App() {
  const [lang, setLang] = useState("en");

  // Textos para los dos idiomas
  const t = {
    en: {
      title: "IMPRUDENT",
      subtitle: "Desire Without Permission",
      btn: "Explore the Sins",
      collection: "The Sins"
    },
    es: {
      title: "IMPRUDENT",
      subtitle: "Deseo Sin Permiso",
      btn: "Explorar los Pecados",
      collection: "Los Pecados"
    }
  };

  const current = t[lang];

  return (
    <div style={{ backgroundColor: "black", color: "white", fontFamily: "Proxima Nova, sans-serif", margin: 0, padding: 0 }}>

      {/* --- SECCIÓN HERO (PORTADA) --- */}
      <section style={{
        height: "100vh",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        overflow: "hidden"
      }}>

        {/* IMAGEN DE FONDO PRINCIPAL */}
        <img
          src="/lustestilo.jpg"
          alt="fondo"
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%", height: "100%",
            objectFit: "cover",
            opacity: 0.5,
            zIndex: 0
          }}
        />

        {/* CAPA OSCURA (OVERLAY) */}
        <div style={{
          position: "absolute",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.6)",
          zIndex: 1
        }} />

        {/* BOTÓN DE IDIOMA (SUPERIOR IZQUIERDA) */}
        <button 
          onClick={() => setLang(lang === "en" ? "es" : "en")}
          style={{
            position: "absolute",
            top: "30px",
            left: "30px",
            zIndex: 10,
            padding: "8px 20px",
            border: "1px solid white",
            color: "white",
            background: "transparent",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            borderRadius: "4px"
          }}
        >
          {lang === "en" ? "ES" : "EN"}
        </button>

        {/* LOGO (SUPERIOR DERECHA) */}
        <img 
          src="/logo.png" 
          alt="logo" 
          style={{ 
            position: "absolute",
            top: "30px",
            right: "30px",
            zIndex: 10,
            width: "100px",
            height: "auto"
          }} 
        />

        {/* CONTENIDO CENTRAL */}
        <div style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "clamp(40px, 10vw, 80px)", // Tamaño fluido
            margin: "0 0 10px 0",
            background: "linear-gradient(to right, #C5A028, #FFF3B0, #D4AF37)",
            WebkitBackgroundClip: "text",
            color: "transparent",
            fontWeight: "bold"
          }}>
            {current.title}
          </h1>

          <p style={{ fontSize: "18px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.8 }}>
            {current.subtitle}
          </p>

          <button 
            onClick={() => {
              document.getElementById("collection").scrollIntoView({ behavior: "smooth" });
            }}
            style={{
              marginTop: "40px",
              padding: "15px 40px",
              border: "1px solid #D4AF37",
              color: "#D4AF37",
              background: "transparent",
              cursor: "pointer",
              fontSize: "14px",
              textTransform: "uppercase",
              letterSpacing: "2px",
              transition: "0.3s"
            }}
          >
            {current.btn}
          </button>
        </div>
      </section>

      {/* --- SECCIÓN COLECCIÓN --- */}
      <section id="collection" style={{ padding: "100px 20px", textAlign: "center" }}>
        
        <h2 style={{
          fontSize: "45px",
          marginBottom: "50px",
          background: "linear-gradient(to right, #C5A028, #FFF3B0, #D4AF37)",
          WebkitBackgroundClip: "text",
          color: "transparent"
        }}>
          {current.collection}
        </h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "30px",
          maxWidth: "1200px",
          margin: "0 auto"
        }}>

          {/* Producto 1 */}
          <div>
            <img src="/lust.jpg" alt="Lust" style={{ width: "100%", borderRadius: "10px" }} />
            <p style={{ marginTop: "15px", fontWeight: "bold", color: "#D4AF37" }}>LUST – Garter Thong</p>
          </div>

          {/* Producto 2 */}
          <div>
            <img src="/pride.jpg" alt="Pride" style={{ width: "100%", borderRadius: "10px" }} />
            <p style={{ marginTop: "15px", fontWeight: "bold", color: "#D4AF37" }}>PRIDE – Bodysuit</p>
          </div>

          {/* Producto 3 */}
          <div>
            <img src="/envy.jpg" alt="Envy" style={{ width: "100%", borderRadius: "10px" }} />
            <p style={{ marginTop: "15px", fontWeight: "bold", color: "#D4AF37" }}>ENVY – Thong</p>
          </div>

          {/* Producto 4 */}
          <div>
            <img src="/greed.jpg" alt="Greed" style={{ width: "100%", borderRadius: "10px" }} />
            <p style={{ marginTop: "15px", fontWeight: "bold", color: "#D4AF37" }}>GREED – Thong</p>
          </div>

          {/* Producto 5 - WRATH (Agregado) */}
          <div>
            <img src="/wrath.jpg" alt="Wrath" style={{ width: "100%", borderRadius: "10px" }} />
            <p style={{ marginTop: "15px", fontWeight: "bold", color: "#D4AF37" }}>WRATH – Bodysuit</p>
          </div>

        </div>
      </section>

      {/* --- FOOTER (REDES SOCIALES) --- */}
      <footer style={{
        padding: "60px 20px",
        backgroundColor: "#0a0a0a",
        borderTop: "1px solid #222",
        textAlign: "center"
      }}>
        
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          flexWrap: "wrap",
          gap: "40px", 
          marginBottom: "30px" 
        }}>
          
          {/* LINK WHATSAPP */}
          <a 
            href="https://wa.me/573332241665" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "white", display: "flex", alignItems: "center", gap: "12px" }}
          >
            <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WA" style={{ width: "28px" }} />
            <span style={{ fontSize: "16px", fontWeight: "500" }}>WhatsApp</span>
          </a>

          {/* LINK INSTAGRAM */}
          <a 
            href="https://instagram.com/imprudent.shop" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "white", display: "flex", alignItems: "center", gap: "12px" }}
          >
            <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="IG" style={{ width: "28px" }} />
            <span style={{ fontSize: "16px", fontWeight: "500" }}>@imprudent.shop</span>
          </a>

        </div>

        <p style={{ fontSize: "12px", opacity: 0.4, letterSpacing: "1px" }}>
          © 2026 IMPRUDENT. TODOS LOS DERECHOS RESERVADOS.
        </p>
      </footer>

    </div>
  );
}